import React from "react";
import { cn } from "@/lib/utils";

// Bubble button icon presets — kept in sync with the widget copy in
// apps/widget-v2/src/components/bubbleIcons.js.
export const DEFAULT_BUBBLE_ICON = "pingup";

export const BUBBLE_ICONS = {
  pingup: {
    label: "PingUp",
    viewBox: "0 0 189.92 170.08",
    stroke: false,
    inner:
      '<path d="M174.92,14.92c-4.63-4.66-10.05-8.32-16.11-10.91-6.26-2.66-12.91-4.01-19.76-4.01h-63.2c-5.87,0-15.21,1.05-22.21,4.02-6.05,2.58-11.46,6.26-16.11,10.91-.2.2-11.02,11.08-17.58,17.68l-4.91,4.94c-4.63,4.66-8.27,10.09-10.84,16.17C1.56,60.01.23,66.67.23,73.52v75.41c0,1.43.19,2.87.53,4.32,2.21,9.77,11.03,16.84,21.06,16.84.51,0,1.03-.02,1.6-.07,3.28-.15,6.18-.89,8.84-2.28l28.55-17.28c.48-.25,1.01-.39,1.54-.39h54.17c6.86,0,13.51-1.36,19.76-4.02,6.04-2.56,11.46-6.23,16.09-10.9l19-19.11c1.39-1.4,2.53-2.55,3.45-3.57l.05.05c4.65-4.67,8.28-10.1,10.82-16.15,2.65-6.28,4-12.94,4-19.81v-25.63c0-6.88-1.34-13.54-4-19.81-2.55-6.06-6.19-11.49-10.82-16.15l.05-.02ZM178.15,76.53c0,5.31-1.03,10.45-3.08,15.32-1.97,4.68-4.79,8.88-8.37,12.48h0s-22.39,22.51-22.5,22.63c-3.58,3.6-7.76,6.43-12.42,8.41-4.83,2.06-9.95,3.09-15.22,3.09h-54.18c-2.61,0-5.17.68-7.42,1.99l-28.05,17c-1.19.63-2.46.93-4.16.98-.3.02-.59.05-.9.05-4.81,0-8.82-3.39-9.79-7.91-.15-.57-.23-1.12-.23-1.66v-75.39c0-5.3,1.03-10.44,3.07-15.31,1.98-4.68,4.8-8.88,8.38-12.48.08-.08,22.45-22.59,22.49-22.63,3.58-3.6,7.77-6.43,12.42-8.42,4.83-2.05,12.39-3.08,17.66-3.08h63.2c5.27,0,10.39,1.03,15.21,3.08,4.66,1.99,8.84,4.82,12.42,8.42,3.58,3.6,6.4,7.81,8.37,12.49,2.05,4.84,3.08,10,3.08,15.31v25.63h.02Z"/><path d="M141.42,99.84v-27.29c0-13.92-11.19-25.21-25.06-25.41H50.91c-14.03,0-25.41,11.38-25.41,25.41v27.29c0,14.03,11.38,25.41,25.41,25.41h65.46c13.88-.2,25.06-11.49,25.06-25.41h-.01ZM50.91,96.46c-5.67,0-10.25-4.59-10.25-10.25s4.59-10.27,10.25-10.27,10.27,4.6,10.27,10.27-4.6,10.25-10.27,10.25ZM83.36,96.45c-5.67,0-10.27-4.59-10.27-10.25h20.52c0,5.67-4.59,10.25-10.25,10.25ZM116.02,96.46c-5.67,0-10.27-4.59-10.27-10.25s4.6-10.27,10.27-10.27,10.25,4.6,10.25,10.27-4.59,10.25-10.25,10.25Z"/>',
  },
  bot: {
    label: "Bot",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/>',
  },
  "bot-message-square": {
    label: "Bot chat",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M12 6V2H8"/><path d="M15 11v2"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/><path d="M9 11v2"/>',
  },
  "message-circle-more": {
    label: "Chat",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/>',
  },
  "message-square-more": {
    label: "Messaggi",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/><path d="M12 11h.01"/><path d="M16 11h.01"/><path d="M8 11h.01"/>',
  },
  "message-circle-question-mark": {
    label: "Domande",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
  },
  "message-circle-heart": {
    label: "Cuore",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/><path d="M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 5.004 2.224 3 3 0 0 1-.832 2.083l-3.447 3.62a1 1 0 0 1-1.45-.001z"/>',
  },
  headset: {
    label: "Supporto",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/>',
  },
  rabbit: {
    label: "Coniglio",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="M13 16a3 3 0 0 1 2.24 5"/><path d="M18 12h.01"/><path d="M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3"/><path d="M20 8.54V4a2 2 0 1 0-4 0v3"/><path d="M7.612 12.524a3 3 0 1 0-1.6 4.3"/>',
  },
  turtle: {
    label: "Tartaruga",
    viewBox: "0 0 24 24",
    stroke: true,
    inner:
      '<path d="m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z"/><path d="M4.82 7.9 8 10"/><path d="M15.18 7.9 12 10"/><path d="M16.93 10H20a2 2 0 0 1 0 4H2"/>',
  },
};

export default function BubbleIconPicker({ value, onChange }) {
  const current = value || DEFAULT_BUBBLE_ICON;
  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(BUBBLE_ICONS).map(([key, def]) => {
        const selected = current === key;
        return (
          <button
            key={key}
            type="button"
            title={def.label}
            aria-label={def.label}
            onClick={() => onChange?.(key)}
            className={cn(
              "flex h-11 w-11 items-center justify-center rounded-lg border transition-colors",
              selected
                ? "border-primary ring-2 ring-primary/30 text-primary"
                : "border-input text-muted-foreground hover:bg-accent hover:text-foreground"
            )}
          >
            <svg
              viewBox={def.viewBox}
              className="h-6 w-6"
              {...(def.stroke
                ? {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                  }
                : { fill: "currentColor" })}
              dangerouslySetInnerHTML={{ __html: def.inner }}
            />
          </button>
        );
      })}
    </div>
  );
}
